import React, { useState, useRef, useContext } from 'react';
import { Link } from 'react-router-dom';
import ConfigContext from '../../contexts/ConfigContext';
import { useAddCustomerToListMutation } from '../../redux/slices/userSlice';

// Components
import Modal from './Modal';

import styles from './Footer.module.postcss';

function FooterListItem({ title, url }) {
  return (
    <div className={styles.Footer_listItem}>
      <Link to={url}>
        {title}
      </Link>
    </div>
  );
}

function Footer() {
  const { logo, site_title, facebook, instagram, twitter, vehicle_type } = useContext(ConfigContext);
  const vehicleType = vehicle_type.toLowerCase();

  const [showMailingListModal, setShowMailingListModal] = useState(false);
  const mailingListEmail = useRef(null);
  const [addCustomerToList, { isLoading }] = useAddCustomerToListMutation();

  const handleMailingListSubmit = async (e) => {
    e.preventDefault();
    addCustomerToList(mailingListEmail.current.value).unwrap().then(() => {
      setShowMailingListModal(true);
    });
  };

  const currentYear = new Date().getFullYear();
  const logoImg = (
    <img src={logo} alt={site_title} width='180' height='30' />
  );

  return (
    <footer className={styles.Footer}>
      <div className='Section--extraPadding'>
        <div className='u-flex'>
          <Link to='/'>
            {logoImg}
          </Link>
        </div>

        <div className={styles.Footer_listWrapper}>
          <div className={styles.Footer_list}>
            <h3 className='u-phosphate u-mb1'>Explore</h3>
            <FooterListItem title='Add your business' url='/vendors' />
            <FooterListItem title={`Book a food ${vehicleType}`} url='/catering' />
            <FooterListItem title={`Hire a food ${vehicleType}`} url='/hire-a-food-truck' />
            <FooterListItem title={`Food ${vehicle_type} rental`} url='/food-truck-rental' />
            <FooterListItem title='Catering prices' url='/food-truck-catering/prices' />
          </div>
          <div className={styles.Footer_list}>
            <h3 className='u-phosphate u-mb1'>Community</h3>
            <FooterListItem title='About' url='/about' />
            <FooterListItem title='Blog' url='/blog' />
            <FooterListItem title='Support' url='/support' />
            <FooterListItem title='Terms & Conditions' url='/terms-and-conditions' />
            <FooterListItem title='Privacy Policy' url='/privacy-policy' />
          </div>
          <div className={styles.Footer_list}>
            <h3 className='u-phosphate u-mb1'>Event Services</h3>
            <FooterListItem title='Corporate Catering' url='/food-truck-catering/corporate-catering' />
            <FooterListItem title='Wedding Catering' url='/food-truck-catering/wedding-catering' />
            <FooterListItem title='Private Parties' url='/food-truck-catering/private-parties' />
            <FooterListItem title='Events & Festivals' url='/food-truck-catering/community-events' />
            <FooterListItem title='Fundraisers' url='/food-truck-catering/fundraiser' />
            <FooterListItem title='Special Occasions' url='/food-truck-catering/special-occasions' />
          </div>
          <div className={styles.Footer_list}>
            <h3 className='u-phosphate u-mb1'>Catering Services</h3>
            <FooterListItem title={`Taco ${vehicleType} catering`} url='/food-truck-catering/taco-catering' />
            <FooterListItem title={`BBQ ${vehicleType} catering`} url='/food-truck-catering/bbq-catering' />
            <FooterListItem title={`Pizza ${vehicleType} catering`} url='/food-truck-catering/pizza-catering' />
            <FooterListItem title={`Asian ${vehicleType} catering`} url='/food-truck-catering/asian-catering' />
            <FooterListItem title={`Burger ${vehicleType} catering`} url='/food-truck-catering/burger-catering' />
            <FooterListItem title={`Dessert ${vehicleType} catering`} url='/food-truck-catering/dessert-catering' />
            <FooterListItem title={`Breakfast ${vehicleType} catering`} url='/food-truck-catering/breakfast-catering' />
          </div>
        </div>
      </div>
      <div className={styles.Footer_wrapper + ' Section'}>
        <div className={styles.Footer_section}>
          <nav aria-label='Footer'>
            <Link to='/support' className={styles.Footer_navLink}>Support</Link>
            <Link to='/blog' className={styles.Footer_navLink}>Blog</Link>
            <Link to='/privacy-policy' className={styles.Footer_navLink}>Privacy Policy</Link>
            <Link to='/terms-and-conditions' className={styles.Footer_navLink}>Terms of Service</Link>
          </nav>

          <div className={styles.Footer_finePrint}>
            <p>
              Powered by <a href='http://www.curbsideprovisions.com'>Curbside Provisions</a>&nbsp;
              <span>&copy; {currentYear} All Rights Reserved</span>
            </p>
          </div>
        </div>

        <div className={styles.Footer_section}>
          <p className={styles.Footer_heading}>Follow us on Social Media</p>
          <div className={styles.Footer_social}>
            <a href={facebook}>
              <img src='/static/images/icons/footer/facebook.svg' alt='Facebook' width='30' height='30' />
            </a>
            <a href={'https://www.instagram.com/' + instagram}>
              <img src='/static/images/icons/footer/instagram.svg' alt='Instagram' width='30' height='30' />
            </a>
            <a href={'http://twitter.com/' + twitter}>
              <img src='/static/images/icons/footer/twitter.svg' alt='Twitter' width='30' height='30' />
            </a>
          </div>
        </div>

        <div className={styles.Footer_section}>
          <label htmlFor='mailing-list-email' className={styles.Footer_heading}>Join our mailing list!</label>
          <form className={styles.InlineForm} onSubmit={handleMailingListSubmit}>
            <input type='email' id='mailing-list-email' ref={mailingListEmail} placeholder='Enter email...' autoComplete='email' required />
            <button className='Button' type='submit' disabled={isLoading}>
              Submit
            </button>
          </form>
        </div>
      </div>

      { showMailingListModal &&
        <Modal>
          <h4>Subscription Confirmed</h4>
          <p>Your subscription to our list has been confirmed.</p>
          <p>Thank you for subscribing!</p>
          <p>
            {site_title}<br/>
            113 Cherry Street<br/>
            #45647<br/>
            Seattle, WA 98104
          </p>
          <button className='Button' type='button' onClick={() => setShowMailingListModal(false)}>
            Close
          </button>
        </Modal>
      }
    </footer>
  );
}

export default Footer;
